module.exports = __webpack_public_path__ + "img/Flying_kid2.098dd2af.png";